import Container from "./core/Container"
import Heading from "./core/Heading"
import Paragraph from "./core/Paragraph"
import Link from "./core/Link"
import Image from "./core/Image"

export default function Footer() {
    const socialLinks = [
        {
            name: "Instagram",
            url: "https://www.instagram.com/digibezstresu/",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.98-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.98-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
            )
        },
        {
            name: "YouTube",
            url: "https://www.youtube.com/@digibezstresu",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
            )
        },
        {
            name: "Facebook",
            url: "https://www.facebook.com/profile.php?id=61587167375004",
            icon: (
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
            )
        }
    ]

    return(
        <Container className="w-full bg-gradient-to-r from-main to-second py-10 md:py-12 relative overflow-hidden">
            {/* Dekorativní obrázek v pozadí */}
            <div className="absolute right-0 bottom-0 opacity-20 pointer-events-none hidden md:block">
                <Image 
                    src="./img/digiboy_thumb_up.png" 
                    alt="DigiBoy decoration"
                    className="w-48 lg:w-64 h-auto"
                />
            </div>

            <Container bgColor="transparent" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <Container bgColor="transparent" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8">
                    {/* Logo/Brand sekce */}
                    <Container bgColor="transparent" className="lg:col-span-2">
                        <Container bgColor="transparent" className="flex items-center gap-4 mb-3">
                            <Image 
                                width={85} 
                                height={85} 
                                src="logo500x500_transparent.png"
                                alt="digibezstresu Logo"
                            />
                            <Heading variant="h2" color="white">
                                digibezstresu
                            </Heading>
                        </Container>
                        
                        <Paragraph variant="small_white">
                            Pomáháme lidem zorientovat se v rychle se měnícím světě digitálních technologií a efektivně je využívat v praxi.
                        </Paragraph>
                        {/* Sociální sítě */}
                        <Container bgColor="transparent" className="flex gap-3 mt-4">
                            {socialLinks.map((social, index) => (
                                <a
                                    key={index}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center text-white hover:bg-white/30 hover:scale-110 transition-all duration-300"
                                    aria-label={social.name}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </Container>
                    </Container>

                    {/* Kontakt sekce */}
                    <Container bgColor="transparent">
                        <Heading variant="h4" color="white" className="mb-4">
                            Kontakt
                        </Heading>
                        <Container bgColor="transparent" className="space-y-3">
                            <a href="mailto:info@digibezstresu.cz" className="flex items-center text-white/90 hover:text-white transition-colors text-sm sm:text-base">
                                <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                info@digibezstresu.cz
                            </a>
                            <a href="tel:+420774993226" className="flex items-center text-white/90 hover:text-white transition-colors text-sm sm:text-base">
                                <svg className="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                +420 774 993 226
                            </a>
                        </Container>
                    </Container>

                    {/* Odkazy sekce */}
                    <Container bgColor="transparent">
                        <Heading variant="h4" color="white" className="mb-4">
                            Další odkazy
                        </Heading>
                        <Container bgColor="transparent" className="space-y-3">
                            <Link 
                                to="/podminky_zpracovani" 
                                className="block text-white/90 hover:text-white text-sm sm:text-base transition-colors hover:underline"
                            >
                                Zpracování osobních údajů
                            </Link>
                            <Link 
                                to="/obchodni_podminky" 
                                className="block text-white/90 hover:text-white text-sm sm:text-base transition-colors hover:underline"
                            >
                                Obchodní podmínky
                            </Link>
                            <Link 
                                to="/kurzy" 
                                className="block text-white/90 hover:text-white text-sm sm:text-base transition-colors hover:underline"
                            >
                                Naše kurzy
                            </Link>
                        </Container>
                    </Container>
                </Container>

                {/* Copyright */}
                <Container bgColor="transparent" className="pt-6 border-t border-white/20">
                    <Paragraph variant="small_white">
                        © {new Date().getFullYear()} digibezstresu. Všechna práva vyhrazena.
                    </Paragraph>
                </Container>
            </Container>
        </Container>
    )
}
